import { useAuth0 } from "@auth0/auth0-react";

export default function EmailVerified() {
  const { loginWithRedirect } = useAuth0();

  return (
    <section className="auth-page">
      <div className="auth-container">
        <h2>E-mail potwierdzony</h2>

        <p>
          Twój adres e-mail został zweryfikowany.
          Możesz teraz zalogować się do soMeet.
        </p>

        <button
          onClick={() =>
            loginWithRedirect({
              appState: {
                returnTo: "/onboarding",
              },
              authorizationParams: {
                audience: "https://someet-api",
              },
            })
          }
        >
          Zaloguj się
        </button>
      </div>
    </section>
  );
}